import { ActiveRecord, BaseElementWidget, RowContext, SPI, TableWidget, ViewType } from '@kunlun/dependencies';

// 品类榜单-管理商品页面用
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: ['TopHotSaleItemManageTable'],
  })
)
export class TopHotSaleItemManageTable extends TableWidget {

  protected async updateSubviewFieldWidget(context: RowContext, data: ActiveRecord) {
    try {
      await this.rowEditorClosedForUpdate(context, data);
    } catch (e) {
      console.error(e);
    }
  }
}
